import React from 'react';
import { parse } from 'date-fns';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { intlMessage } from 'constants/propTypes';
import { DropdownItem, DropdownMenu, DropdownToggle } from 'components/Dropdown2';
import Message from 'components/Message';
import When from 'components/When';
import { bem } from 'helpers/class-name';
import { format12HourTimeLowercase } from 'helpers/intl-fns';
import { selectLocale } from 'selectors/locale-data';

import Dropdown from '../Dropdown/Dropdown';
import messages from '../messages';
import { getTimes } from './TimePicker.helpers';

import './TimePicker.scss';

const { block, element } = bem('hook-form-time-picker');

const TimePicker = props => {
  const { className, onChange: onChangeBubbleUp = () => {}, toggleLabel } = props;
  let { options, placeholder } = props;
  const locale = useSelector(selectLocale);
  const intl = useIntl();
  options = options || getTimes(intl);
  placeholder = placeholder || messages.placeholder.timePicker;

  return (
    <Dropdown {...props} placeholder={placeholder} className={block('mb-l', className)}>
      {({ hasError, value, onChange: onChangeLocal }) => {
        function onChange(selected) {
          onChangeLocal(selected);
          onChangeBubbleUp(selected);
        }

        const parsedTime = value ? parse(value, 'HH:mm', new Date()) : undefined;
        return (
          <>
            <DropdownToggle placeholder={placeholder} hasError={hasError}>
              <span className={element('toggle-wrapper')}>
                <When predicate={toggleLabel}>
                  <Message className={element('toggle-label')} message={toggleLabel} />
                </When>
                <When predicate={!value}>
                  <Message className={element('toggle-placeholder')} message={placeholder} />
                </When>
                <When predicate={!!value}>{format12HourTimeLowercase(parsedTime, locale)}</When>
              </span>
            </DropdownToggle>
            <DropdownMenu>
              {options.map(({ label, match, value: optionValue }) => {
                return (
                  <DropdownItem
                    key={match}
                    isSelected={optionValue === value}
                    isHighlighted={optionValue === value}
                    onClick={() => {
                      onChange(optionValue);
                    }}>
                    {label}
                  </DropdownItem>
                );
              })}
            </DropdownMenu>
          </>
        );
      }}
    </Dropdown>
  );
};

TimePicker.propTypes = {
  className: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
      match: PropTypes.string,
    })
  ),
  onChange: PropTypes.func,
  placeholder: intlMessage,
  toggleLabel: intlMessage,
};

export default TimePicker;
